import { CalendarDate } from '@internationalized/date';

/**
 * First date when deliverability data is available
 */
export const FIRST_POSSIBLE_DATE = new CalendarDate(2025, 4, 15);

/**
 * Quality indicator thresholds for deliverability metrics
 */
export const QUALITY_THRESHOLDS = {
  deliveryRate: {
    label: 'Delivery rate',
    good: 0.98, // >= 98%
    needs_work: 0.95, // 95%-97.9%
  },
  bounceRate: {
    label: 'Bounce rate',
    good: 0.02, // < 2%
    needs_work: 0.05, // 2%-5%
  },
  spamRate: {
    label: 'Spam rate',
    good: 0.0005, // < 0.05%
    needs_work: 0.001, // 0.05%-0.1%
  },
  openRate: {
    label: 'Open rate',
    good: 0.3, // >= 30%
    needs_work: 0.15, // 15%-29.9%
  },
  clickRate: {
    label: 'Click rate',
    good: 0.02, // >= 2%
    needs_work: 0.01, // 1%-1.9%
  },
} as const;

/**
 * Providers that don't report spam metrics
 */
export const NO_SPAM_PROVIDERS = ['Google Workspace', 'Gmail', 'Googlers'] as const;
